import { useCallback } from "react";
import type { IFlightFilters } from "../../types/interfaces";
import { useFlightSearch } from "./useFlightsSearch";
import type { FlightSearchPagedResultData, FlightSearchParams } from "./types";
import type { FlightSearchType } from "../../types/types";

export const useDepartureFlightSearch = (
  params: FlightSearchParams,
  filters: IFlightFilters | null,
  searchType?: FlightSearchType | null,
) => {
  const select = useCallback(
    (response: FlightSearchPagedResultData) =>
      response.pages.flatMap((page) => page.offers),
    [],
  );

  const query = useFlightSearch(params, filters, { select }, searchType);

  const hasReachedEnd = !query.hasNextPage;
  const isEmpty = !query.result || query.result.length === 0;

  return {
    ...query,
    hasReachedEnd,
    isEmpty,
  };
};
